//angular
import { Injectable, OnDestroy, signal, WritableSignal } from "@angular/core";

//msal
import { MsalBroadcastService, MsalService } from "@azure/msal-angular";
import { AuthenticationResult, EventMessage, EventType } from "@azure/msal-browser";

//rxjs
import { ReplaySubject, Subject, Subscription, filter, takeUntil, lastValueFrom } from "rxjs";

//local imports
import { Messenger, SignalRConnection } from "@app/shared";
import { ApplicationSecurity, ApplicationSecurityLifetime, SecurityConfig, UserLoggedOutMessage } from "@app/core";

/**
 * @summary A service that stores basic shared state for the entire app
 */
@Injectable({
    providedIn: 'root'
})
export class CoreStateService  {

    public testMode: WritableSignal<boolean> = signal(false);
}